<template>
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-md-12">
          <button @click="filter.showFilter()" class="btn btn-warning">Filter Periode</button>
        </div>
      </div>
      <div class="row" v-show="filter.data.filterBox">
        <div class="col-md-2 cariByTanggal" >
          <div class="form-group">
            <input type="text" class="form-control" placeholder="Pilih Bulan..." style="width:100%" @focus="filter.showBulan()" v-model="filter.data.bulanNama" />
          </div>
        </div>
        <div class="col-md-2 cariByTanggal" >
          <div class="form-group">
            <input type="text" class="form-control" placeholder="Pilih Admin..." style="width:100%" @focus="filter.showAdmin()" v-model=" (filter.data.admin === null) ? 'Semua Admin' : filter.data.admin " />
          </div>
        </div>
        <div class="col-md-2 cariByTanggal">
            <div class="form-group">
            <button  class="btn btn-primary" @click="filter.submit()">Cari</button>
          </div>
        </div>
      </div>
      <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="card-title ">Periode Pembukuan</h4>
                    <p class="card-category">Semua Pembayaran yang di terima pada bulan yang di tentukan</p>
                  </div>
                  <div class="col-md-6">
                    <p class="card-title text-right">Total Pendapatan</p>
                    <h4 class="card-title text-right"><strong>{{myGlobal.ribu(theGet.data.Total)}}</strong></h4>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th width="40px">No.</th>
                      <th>Pelanggan</th>
                      <th>Paket</th>
                      <th>Tagihan Bulan</th>
                      <th>Jumlah</th>
                      <th>Bayar Tanggal </th>
                      <th>Admin By </th>
                      <th></th>
                    </thead>
                      <!-- LOADING -->
                    <tbody v-show="data.loading">
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                    </tbody>
                      <!-- DATA -->
                    <tbody v-show="!data.loading">
                      <tr v-for="(u, index) in theGet.data.List">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.unama }}</td>
                        <td>{{ u.pnama }}</td>
                        <td><strong class="text-info">{{ myGlobal.BulanOnly(u.htanggal) }}</strong></td>
                        <td>{{ myGlobal.ribu(u.paket_tarif) }}</td>
                        <td><strong class="text-success">{{ myGlobal.tglIndo(u.bayar_tanggal) }}</strong></td>
                        <td>{{ u.by_admin }}</td>
                      </tr>
                      <!-- NULL -->
                      <tr v-if="theGet.data.List == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
      </div>

      <!-- MODAL -->
			<div class="modal" tabindex="-1" role="dialog" v-show="data.modalBulan">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Pilih Bulan</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalBulan = false">
							  <span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="row">
                <div class="col-md-12">
                  <div class="table-responsive" style="height: 500px;overflow:auto;">
                    <table class="table">
                      <thead class=" text-info">
                        <th>Bulan</th>
                        <th>Aksi</th>
                      </thead>
                      <tbody>
                        <tr v-for="(u, index) in data.bulan">
                          <td>{{ u.nama }}</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="filter.pilihBulan(u.id,u.nama),data.modalBulan = false"> Pilih</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
							</div>
						</div>
					</div>
				</div>
			</div>

      <!-- MODAL -->
			<div class="modal" tabindex="-1" role="dialog" v-show="data.modalAdmin">
				<div class="overlay"></div>
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Pilih Admin</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalAdmin = false">
							  <span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="row">
                <div class="col-md-12" style="height: 400px;overflow:auto">
                  <div class="table-responsive">
                    <table class="table">
                      <thead class=" text-info">
                        <th>No.</th>
                        <th>Nama</th>
                        <th>Aksi</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>0</td>
                          <td>Semua Admin</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="filter.pilihAdmin(null)"> Pilih</button>
                          </td>
                        </tr>
                        <tr>
                          <td>0</td>
                          <td>{{ data.namaQ }}</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="filter.pilihAdmin(data.namaQ)"> Pilih</button>
                          </td>
                        </tr>
                        <tr v-for="(u, index) in data.admin">
                          <td>{{ index+1 }}</td>
                          <td>{{ u.nama }}</td>
                          <td>
                            <button class="btn btn-sm btn-primary" @click="filter.pilihAdmin(u.nama)"> Pilih</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
							</div>
						</div>
					</div>
				</div>
			</div>

      <!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="false">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Tarif Voucher</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="form-group">
                      <label class="bmd-label-floating">Nama Paket</label>
                      <input type="text" class="form-control" placeholder="Nama Paket...">  
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger">Hapus</button>
              <button type="button" class="btn btn-secondary">Cancel</button>
              <button type="button" class="btn btn-success">Simpan</button>
            </div>
          </div>
        </div>
      </div>


    </div>
</template>

<script>
import Vue from 'vue'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

export default {
    name: 'Beranda',
    components: { 
      "Loading" : Loading
    }, 
    setup() {
      const data = reactive({
        filtered: '',
        loading: true,
        bulan : [], 
        admin: [],
        modalBulan: false,
        modalAdmin: false,
        namaQ: ""
      })

      const filter = {
        data: reactive({
          admin: null,
          bulan: "",
          bulanNama: "",
          filterBox: false
        }),
        showFilter() {
          this.data.filterBox = true
        },
        showAdmin() {
          data.modalAdmin = true;
        },
        showBulan() {
          data.modalBulan = true;
        },
        pilihAdmin(nama) {
          this.data.admin = nama;
          data.modalAdmin = false;
        },
        pilihBulan(id,nama) {
          this.data.bulan = id;
          this.data.bulanNama = nama;
        },
        submit() {
          data.loading = true;
          var datax = {
              token: 'TangTung '+sessionStorage.getItem('myToken'),
              bulan: this.data.bulan,
              tahun: sessionStorage.getItem('tahunBase'),
              by: this.data.admin
          };
      
          var apiUrl = inter.PembukuanList();
          myGlobal.call(datax,apiUrl).then(x => {
              //console.log(JSON.stringify(x));
              data.loading = false;
              if (x.status == true) {
                theGet.data.List = x.data;
                theGet.data.Total = x.pesan;
              } else {
                theGet.data.List = null;
              }
          })
        }
      }

      const theGet = {
        data: reactive({
          List: [],
          Total: "0",
        }),
        datae() {
          var datax = {
              token: 'TangTung '+sessionStorage.getItem('myToken'),
              bulan: sessionStorage.getItem('bulanIdBase'),
              tahun: sessionStorage.getItem('tahunBase'),
              by: this.data.admin
          };
      
          var apiUrl = inter.PembukuanList();
          myGlobal.call(datax,apiUrl).then(x => {
              //console.log(JSON.stringify(x));
              data.loading = false;
              if (x.status == true) {
                this.data.List = x.data;
                this.data.Total = x.pesan;

                this.admin();
              } else {
                theGet.data.List = null;
              }
          })
        },
        admin() {
          var datax = {
              token: 'TangTung '+sessionStorage.getItem('myToken')
          };
      
          var apiUrl = inter.AdminList();
          myGlobal.call(datax,apiUrl).then(x => {
              //console.log(JSON.stringify(x));
              if (x.status == true) {
                data.admin = x.data;
              } else {
                //alert(x.pesan);
              }
          })
        }
      }
      return {
        data,
        myGlobal,
        theGet,
        filter
      }

    },
    mounted () {
        document.title = "Periode Pembukuan";

        this.data.namaQ = sessionStorage.getItem('admin');
        this.theGet.datae();

        this.data.bulan = [
          {
            "id": "01",
            "nama": "Januari"
          },
          {
            "id": "02",
            "nama": "Februari"
          },
          {
            "id": "03",
            "nama": "Maret"
          },
          {
            "id": "04",
            "nama": "April"
          },
          {
            "id": "05",
            "nama": "Mei"
          },
          {
            "id": "06",
            "nama": "Juni"
          },
          {
            "id": "07",
            "nama": "Juli"
          },
          {
            "id": "08",
            "nama": "Agustus"
          },
          {
            "id": "09",
            "nama": "September"
          },
          {
            "id": "10",
            "nama": "Oktober"
          },
          {
            "id": "11",
            "nama": "November"
          },
          {
            "id": "12",
            "nama": "Desember"
          }
        ]
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/pembukuan/periode.vue